module.exports = __webpack_public_path__ + "static/media/rating.90a94ca0.svg";